<div class="pop-up">
  <div class="pop-up__figure" *ngIf="figure"></div>
  <div class="pop-up__menu">
    <div class="pop-up__menu__content-menu">
      <div class="pop-up__menu__content-menu__item" *ngFor="let item of 'core.language' | translate"
        (click)="changeLanguage(item)">
        <img [src]="item.icon" [alt]="item.name" *ngIf="item.icon" />
        <span> {{ item.name }} </span>
      </div>
    </div>
  </div>
</div>